import {ObserverBase} from "@share/web-conferences/signal-r/observers/ObserverBase";
import {SignalRMethod} from "@api/repositories/reatime-repository/types";
import {StreamUpdatedInfo} from "@share/web-conferences/types/StreamUpdatedInfo";
import {ObserverData} from "@share/web-conferences/interfaces/signalr/ObserverData";
import {AgoraInterface} from "@share/web-conferences/interfaces/AgoraInterface";
import {AgoraScreenShareInterface} from "@share/web-conferences/interfaces/AgoraScreenShareInterface";
import {StreamTypes} from "@share/web-conferences/enums/StreamTypes";

export class StreamStatusChangeObserver extends ObserverBase {
    method = SignalRMethod.webConferenceStreamsUpdated;

    constructor(
        protected readonly data: ObserverData,
        private readonly agora: AgoraInterface,
        private readonly agoraScreenShare: AgoraScreenShareInterface
    ) {
        super(data);
    }

    async callback(data: any): Promise<void> {
        console.log('streams updated', data);
        try {

            const streamUpdateInfo = JSON.parse(data) as StreamUpdatedInfo;
            const isCurrentUser = streamUpdateInfo.userId == this.data.store.getters['userId'];

            if (isCurrentUser) {
                switch (streamUpdateInfo.streamType) {
                    case StreamTypes.Audio:
                        await this.agora.switchMic(streamUpdateInfo.isEnabled);
                        break;
                    case StreamTypes.Video:
                        await this.agora.switchVideo(streamUpdateInfo.isEnabled);
                        break;
                    //@todo share client
                }
            }
        }
        catch (e) {
            this.data.store.dispatch('reportError', e);
            console.error(e);
        }
    }
}
